import { createAction } from '@reduxjs/toolkit';

/**
 * Actions
 */
export const deepTagReportHowToModalContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>(
    'DeepTagReportFileUploadModalContainer/navigateTo'
  ),
};
